// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bea4C8reX7APWaLC7w_7{gap:8px}`, "",{"version":3,"sources":["webpack://./src/features/CreateOrEdit/NameInput/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,OAAA","sourcesContent":[".name {\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `Bea4C8reX7APWaLC7w_7`
};
export default ___CSS_LOADER_EXPORT___;
